<template>
	<inertia-head title="Investments Transactions" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Investment Transactions</h1>
					<p class="h4 fw-normal text-white-75 fs-sm">Investment Transactions Management</p>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded shadow mb-1">
			<div class="block-content">
				<form @submit.prevent="submit">
					<div class="row">
						<div class="col-md-3">
							<div class="mb-4">
								<label for="" class="form-label">Filter by</label>
								<select
									v-model="form.filter_column"
									class="form-select form-select-sm"
								>
									<option value="i.email">Email</option>
									<option value="u.fname">First Name</option>
									<option value="u.lname">Last Name</option>
									<option value="it.txnid">TXNID</option>
									<option value="it.refid">REFID</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="mb-4">
								<label for="" class="form-label">Search</label>
								<input
									v-model="form.search"
									type="text"
									class="form-control form-control-sm"
								/>
							</div>
						</div>
						<div class="col space-x-1 mb-4">
							<label for="" class="form-label"></label>
							<div>
								<button type="submit" class="btn btn-alt-primary me-1">
									<i class="fa fa-search me-1"></i>
									Display
								</button>
								<button
									@click="$inertia.visit(route('admin.investments.transactions'))"
									type="button"
									class="btn btn-alt-secondary"
								>
									<i class="fa fa-retweet me-1"></i>
									Reset
								</button>
							</div>
						</div>
					</div>

				</form>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="block-content">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead>
							<tr>
								<th>SOURCE</th>
								<th>MEMBER'S INFO</th>
								<th>INVESTMENT</th>
								<th>AMOUNT</th>
								<th>STATUS</th>
								<th class="text-end">SETTLED DATE</th>
								<!-- <th class="text-end">::::</th> -->
							</tr>
						</thead>
						<tbody class="fs-sm">
							<tr
								v-for="(invest, index) in investments.data"
								:key="invest.invest_trans_uuid"
							>
								<td>{{invest.invest_source}}</td>
								<td nowrap="">
									{{invest.fname}} {{invest.mname1}} {{invest.lname}} <span class="badge bg-info">{{invest.current_rank}}</span>
									<div class="text-info"><sub>{{invest.email}}</sub></div>
									<div><sub>EXPIRY: {{invest.expiry}}</sub></div>
								</td>
								<td>{{invest.invest_code}} - {{invest.invest_name}}</td>
								<td>
									<span class="badge bg-secondary">{{invest.mop}}</span>
									<div>
										PHP {{invest.amount_format}}
									</div>
								</td>
								<td>
									<span :class="{'text-success':invest.status=='S','text-warning':invest.status=='P'}">{{invest.status}}</span>
								</td>
								<td class="text-end">
									{{invest.settled_date}}
									<div><sub>{{invest.settled_time}}</sub></div>
								</td>
								<!-- <td class="text-end">
									<div>
										<button @click="modalToggle(index)" type="button" :disabled="invest.status!='S'" class="btn btn-sm btn-alt-info"><i class="fa fa-search"></i></button>
									</div>
								</td> -->
							</tr>
							<tr v-if="investments.data.length == 0">
								<td colspan="7" class="text-center text-danger p-3">NO DATA FOUND</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination :collections="investments" />
			</div>
		</div>

	</div>
</template>

<script>
import { onMounted, watch, ref } from 'vue';
import AuthLayout from '../../../Layouts/AuthLayout';
import { useForm } from '@inertiajs/inertia-vue3';
import { createToaster } from '@meforma/vue-toaster';

export default {
	layout: AuthLayout,
	props: {
		investments 	: Object,
		filter_column 	: String,
		search 			: String,
		api_response 	: Object,
		errors		 	: Object
	},
	setup(props) {
		const action = ref('verify');
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const form = useForm({
			filter_column 	: props.filter_column,
			search 			: props.search,
		})

		const submit = () => {
			form.get(route('admin.investments.transactions'), {
				preserveState: true,
				preserveScroll: true,
				only:['investments','filter_column','search']
			})
		}

		const selectedInvestment = ref(null);

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{	
				// if(value.result=="success")
				// {	
				// 	var action_msg = transactionModal.value.action=='reject'?'rejected':'verified'
				// 	toast.show("Successfully "+action_msg, { type: value.result});
				// }else
				// {
				// 	toast.show("Failed to "+transactionModal.value.action, { type: "error"});
				// }
			}
		})

		return {
			action,
			form,
			submit,
			selectedInvestment,
		}
	},
}
</script>
